export function canRunWebGlSmoothly(): boolean {
  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  try {
    const nav = navigator || {};
    const { deviceMemory } = nav as any;
    const { hardwareConcurrency } = nav;

    // CPU check - be more conservative and handle undefined/null
    const hasAdequateCPU = typeof hardwareConcurrency === 'number' && hardwareConcurrency > 2;

    // Memory check - only fail if we know memory is insufficient
    // If deviceMemory is undefined (not supported), assume it's adequate
    const hasAdequateMemory = deviceMemory === undefined || (typeof deviceMemory === 'number' && deviceMemory >= 4);

    // Early return if hardware is definitely inadequate
    if (!hasAdequateCPU || !hasAdequateMemory) {
      return false;
    }

    // Check if canvas creation is supported
    if (!document.createElement) {
      return false;
    }

    const canvas = document.createElement('canvas');

    // Set canvas size to minimal to avoid memory issues
    canvas.width = 1;
    canvas.height = 1;

    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return !!gl;
  } catch (e) {
    return false;
  }
}
